import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import ChangePassword from "./pages/ChangePassword";
import Dashboard from "./pages/Dashboard";
import SearchResults from "./pages/SearchResults";
import Drivers from "./pages/Drivers";
import DriverDetail from "./pages/DriverDetail";
import Vehicles from "./pages/Vehicles";
import VehicleDetail from "./pages/VehicleDetail";
import Licenses from "./pages/Licenses";
import Structures from "./pages/Structures";
import ImportWizard from "./pages/ImportWizard";
import Statistics from "./pages/Statistics";
import AuditLogs from "./pages/AuditLogs";
import Users from "./pages/Users";
import Roles from "./pages/Roles";
import Settings from "./pages/Settings";
import Profile from "./pages/Profile";
import { NotFound } from "./pages/ErrorPages";

function P({ children, perm }) {
  return <ProtectedRoute perm={perm}>{children}</ProtectedRoute>;
}

function Home() {
  const { hasPerm } = useAuth();
  return hasPerm("VIEW_DASHBOARD") ? <Dashboard /> : <Navigate to="/recherche" replace />;
}

function App() {
  return (
    <div className="App">
      <ThemeProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/connexion" element={<Login />} />
              <Route path="/changer-mot-de-passe" element={<P><ChangePassword /></P>} />
              <Route element={<P><Layout /></P>}>
                <Route path="/" element={<Home />} />
                <Route path="/recherche" element={<P perm="SEARCH_DRIVER"><SearchResults /></P>} />
                <Route path="/conducteurs" element={<P perm="VIEW_DRIVER"><Drivers /></P>} />
                <Route path="/conducteurs/:id" element={<P perm="VIEW_DRIVER"><DriverDetail /></P>} />
                <Route path="/vehicules" element={<P perm="VIEW_VEHICLE"><Vehicles /></P>} />
                <Route path="/vehicules/:id" element={<P perm="VIEW_VEHICLE"><VehicleDetail /></P>} />
                <Route path="/permis" element={<P perm="VIEW_LICENSE"><Licenses /></P>} />
                <Route path="/structures" element={<P perm="VIEW_ORGANIZATION"><Structures /></P>} />
                <Route path="/importation" element={<P perm="IMPORT_DATA"><ImportWizard /></P>} />
                <Route path="/statistiques" element={<P perm="VIEW_STATISTICS"><Statistics /></P>} />
                <Route path="/historique" element={<P perm="VIEW_AUDIT_LOGS"><AuditLogs /></P>} />
                <Route path="/admin/utilisateurs" element={<P perm="MANAGE_USERS"><Users /></P>} />
                <Route path="/admin/securite" element={<P perm="MANAGE_ROLES"><Roles /></P>} />
                <Route path="/admin/parametres" element={<P perm="MANAGE_SETTINGS"><Settings /></P>} />
                <Route path="/profil" element={<Profile />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
        </AuthProvider>
      </ThemeProvider>
    </div>
  );
}

export default App;
